import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 19 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33199 0H10.6678C11.1225 0 11.4915 0.375979 11.4915 0.841007V2.29982H17.1754C18.1833 2.29982 19 3.13368 19 4.16283V22.137C19 23.1661 18.1833 24 17.1754 24H1.82459C0.816665 24 0 23.1661 0 22.137V4.16283C0 3.13368 0.816665 2.29982 1.82459 2.29982H7.50833V0.841007C7.50833 0.375979 7.8773 0 8.33199 0ZM8.48771 2.82455C8.4881 2.81636 8.4883 2.80811 8.4883 2.79982C8.4883 2.79153 8.4881 2.78329 8.48771 2.77509V1.00001H10.5121V2.77963C10.5118 2.78633 10.5117 2.79306 10.5117 2.79982C10.5117 2.80659 10.5118 2.81332 10.5121 2.82001V3.83303H8.48771V2.82455ZM7.50833 3.29983H1.82459C1.35756 3.29983 0.979381 3.68597 0.979381 4.16283V22.137C0.979381 22.6138 1.35756 23 1.82459 23H17.1754C17.6424 23 18.0206 22.6138 18.0206 22.137V4.16283C18.0206 3.68597 17.6424 3.29983 17.1754 3.29983H11.4915V3.99303C11.4915 4.45744 11.1221 4.83304 10.6678 4.83304H8.33199C7.87767 4.83304 7.50833 4.45744 7.50833 3.99303V3.29983ZM9.49373 11.8201C10.8267 11.8038 11.8937 10.6862 11.8765 9.32562C11.8593 7.965 10.7661 6.87554 9.43355 6.8931C8.10183 6.90941 7.03522 8.02603 7.05119 9.38707C7.06716 10.747 8.16144 11.8364 9.49373 11.8201ZM9.44574 7.89303C10.2376 7.8826 10.887 8.5298 10.8972 9.33854C10.9074 10.1467 10.2736 10.8104 9.48199 10.8201C8.69026 10.8298 8.03998 10.1825 8.0305 9.37508C8.02101 8.56607 8.65465 7.90272 9.44574 7.89303ZM9.51131 13.3108C7.39297 13.3374 5.69585 15.1139 5.7219 17.2777C5.72523 17.5538 5.5087 17.7804 5.23827 17.7838C4.96784 17.7872 4.74592 17.5661 4.74259 17.29C4.70989 14.574 6.84001 12.3442 9.49907 12.3108C12.16 12.2763 14.344 14.4512 14.3767 17.1677C14.38 17.4438 14.1635 17.6704 13.8931 17.6738C13.6226 17.6772 13.4007 17.4561 13.3974 17.18C13.3713 15.0159 11.6314 13.2833 9.51131 13.3108Z"
      />
    </svg>
  );
}